import CrossSVG from '../../assets/svg/x.svg';
export default CrossSVG;
